import { render, staticRenderFns } from "./FavoriteAction.component.vue?vue&type=template&id=0379b206&scoped=true"
import script from "./FavoriteAction.component.vue?vue&type=script&lang=js"
export * from "./FavoriteAction.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0379b206",
  null
  
)

export default component.exports